import React from 'react';
import './Map.css';

const Map = () => {
  const src = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2919.677825262762!2d-81.25000952487656!3d42.96399329673495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882ef228c3901ded%3A0x35e134615e21cd4d!2s2%20Franklin%20Ave%2C%20London%2C%20ON%20N6C%202G7!5e0!3m2!1sen!2sca!4v1688768609825!5m2!1sen!2sca";

  return (
    <section className='map section'>
      <iframe
        src={src}
        className='map-content'
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
    </section>
  );
};

export default Map;
